import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=18bb7047&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=ts"
export * from "./CustomModal.vue?vue&type=script&lang=ts"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=18bb7047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb7047",
  null
  
)

export default component.exports